// Thin wrapper around sonner so call sites stay tidy and we can change
// the underlying toast library without touching every component.
import { toast as sonnerToast } from 'sonner';

export const toast = {
  success: (message: string) => sonnerToast.success(message),
  error: (message: string) => sonnerToast.error(message),
  info: (message: string) => sonnerToast(message),
};
